import { AxiosStatusCode } from 'smg/axios';
import * as buttons from 'smg/buttons';
import * as models from 'smg/customer-api/models';
import * as session from 'smg/customer-api/session';
import { ReportValidity } from 'smg/form';
import { InitGoogleCredentialHandler } from 'smg/googlesignin';
import Modal from 'smg/modal';
import QueryString from 'smg/querystring';
import { SafeReturnPath } from 'smg/url';
import { Relref } from '../hugo';
import * as login from '../login';

main();

function main() {
    const returnTo = QueryString().get('return');
    const landingPage = SafeReturnPath(returnTo, Relref('/dashboard'));

    InitGoogleCredentialHandler(landingPage);

    if (returnTo) {
        const encoded = encodeURIComponent(landingPage);
        const $createAccount = document.querySelector('#create-account-link') as HTMLAnchorElement;
        $createAccount.href = `${Relref('/join')}?return=${encoded}`;
        const $phoneLogin = document.querySelector('#login-phone-link') as HTMLAnchorElement | null;
        if ($phoneLogin) {
            $phoneLogin.href = `${Relref('/login')}?return=${encoded}`;
        }
    }

    const email = document.querySelector('#email') as HTMLInputElement;
    const password = document.querySelector('#password') as HTMLInputElement;
    const form = document.querySelector('#login-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const welcome = form.querySelector('h1') as HTMLHeadElement;
    const loginCodes = document.querySelectorAll<HTMLAnchorElement>('.login-code');

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const showAlert = (type: 'generic' | 'invalid-email' | 'email-unverified') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        welcome.after(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    form.noValidate = true;
    form?.addEventListener('submit', e => {
        e.preventDefault();

        if (!ReportValidity(form)) {
            return false;
        }

        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);

        session.CreateSession({
            'email': email.value,
            'password': password.value,
        }).then(resp => {
            const data = models.SessionCreateResponse.fromJSON(resp.data);
            if (data.token) {
                session.SetLoginToken(data.token);
                window.location.href = landingPage;
                return;
            }

            throw Error('Login failed!');
        }).catch(async err => {
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);

            switch (AxiosStatusCode(err)) {
            case 400:
                showAlert('invalid-email');
                return;
            case 401: {
                const prompt = await login.PromptLoginCode({ email: email.value });

                await prompt.login.then(() => window.location.href = landingPage);

                return prompt.createCode;
            }
            }
            showAlert('generic');
        });
    });

    loginCodes.forEach(loginCode => {
        loginCode.addEventListener('click', e => {
            e.preventDefault();

            const body = (document.querySelector('#modal-login-code-email') as HTMLTemplateElement).content.cloneNode(true) as DocumentFragment;

            const modalEmail = body.querySelector('#modal-email') as HTMLInputElement;
            modalEmail.value = email.value;

            new Modal({
                body,
                onSubmit: async () => {
                    const prompt = await login.PromptLoginCode({ email: modalEmail.value });

                    void prompt.login.then(() => window.location.href = landingPage);

                    return prompt.createCode;
                },
                submitAutoFocus: false,
            });

            setTimeout(() => {
                modalEmail.focus();
                modalEmail.select();
            });
        });
    });

    const googleBtn = document.querySelector('#google-cover-btn') as HTMLElement;

    googleBtn.addEventListener('click', () => {
        const hiddenGoogleBtn = document.querySelector('.g_id_signin') as HTMLElement;
        const googleTarget = hiddenGoogleBtn.querySelector('div[tabindex="0"]') as HTMLElement;

        googleTarget.dispatchEvent(new PointerEvent('click'));
    });
}
